import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, DrawerProps, useDisclosure } from '@chakra-ui/react'
import React from 'react'

type Props = {
  children?: React.ReactNode,
  [x: string]: any,
  title: string,
  drawerSize?: string,
} & DrawerProps;

const CustomDrawer = React.forwardRef(
  ({title, data, children, drawerSize, ...rest}: Props, ref) => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    React.useImperativeHandle(ref, () => ({
      onOpen,
      onClose,
    }));

    return (
      <Drawer {...rest} onClose={onClose} isOpen={isOpen} size={drawerSize && drawerSize || 'lg'}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{title}</DrawerHeader>
          <DrawerBody>
            {children}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    )
  }
)

export default CustomDrawer;